import React, { useState, useEffect } from 'react';


const interval = 4000;
function ImageSlider({images}) {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentImageIndex((currentImageIndex + 1) % images.length);
    }, interval);
    return () => clearInterval(intervalId);
  }, [currentImageIndex, images.length, interval]);

  const handlePrevClick = () => {
    setCurrentImageIndex((currentImageIndex + images.length - 1) % images.length);
  };

  const handleNextClick = () => {
    setCurrentImageIndex((currentImageIndex + 1) % images.length);
  };

  return (
    <div>
      <div className='image-slideshow-container'>
        <div className="slideshow-btn-container">
          <button className='image-slideshow-btn' onClick={handlePrevClick}>❮</button>
        </div>

        <div className="image-slideshow">
          <img src={images[currentImageIndex]} alt="Slider" />
        </div>
        <div className="slideshow-btn-container">
          <button className='image-slideshow-btn' onClick={handleNextClick}>❯</button>
        </div>
      </div>
      <div className="image-slideshow-caption">
      {/* <p>Caption </p> */}

      </div>
      

    </div>

  );
}

export default ImageSlider;
